export const clientsSlideShowData = [
  {
    src: 'partner-1.svg',
    alt: 'partner 1',
  },
  {
    src: 'partner-2.svg',
    alt: 'partner 2',
  },
  {
    src: 'partner-3.svg',
    alt: 'partner 3',
  },
  {
    src: 'partner-4.svg',
    alt: 'partner 4',
  },
  {
    src: 'partner-5.svg',
    alt: 'partner 5',
  },
  {
    src: 'partner-6.svg',
    alt: 'partner 6',
  },
  {
    src: 'partner-1.svg',
    alt: 'partner 1',
  },
  {
    src: 'partner-2.svg',
    alt: 'partner 2',
  },
  {
    src: 'partner-3.svg',
    alt: 'partner 3',
  },
];
